import React from "react";
import ReactDOM from "react-dom";
import "./assets/themes/custom/npamedicare/css/bootstrap.css";
import "./components/Common/style.css";
import App from "./App.jsx";
import * as serviceWorker from "./serviceWorker";
import '@fortawesome/fontawesome-free/css/all.min.css';
import '@mdi/font/css/materialdesignicons.min.css';

// Handle external redirects before React mounts to avoid any flash
const externalRedirects = {
  "/m3p": "https://www.primetherapeutics.com/",
};


if (externalRedirects[window.location.pathname]) {
  window.location.replace(externalRedirects[window.location.pathname]);
} else {
  ReactDOM.render(
    <App />,
    document.getElementById("root")
  );
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
